/**
 * NOTE: this file should not import any node modules, it needs to be just enum / type / interfaces
 * This file is shared with front-end
 */

export enum Roles {
    PlatformStaff = 0,
    LibraryAdmin = 1,
    BranchSettings = 2,
    Staff = 3,
    StaffLimited = 4,
    External = 5,
    IncidentAccessOnly = 6,
    InventoryScanner = 99
}
